import axios from 'axios';
import { API } from '../shared/api/Api';

const createBlogService = (token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    const multipartConfig = {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        }
    };

    return {
        // Categories
        getAllCategories: async () => {
            const { data } = await axios.get(API.Blog.Categories.app_blog_categories_all, config);
            return data;
        },

        // Posts
        getAllPosts: async (params = {}) => {
            const { data } = await axios.get(API.Blog.Posts.app_blog_categories_posts_all, { ...config, params });
            return data;
        },

        getPostsByCategory: async (categoryId, params = {}) => {
            const { data } = await axios.get(`${API.Blog.Categories.app_blog_categories_allPostsCategory}/${categoryId}`, { ...config, params });
            return data;
        },

        getPostDetails: async (postId) => {
            const { data } = await axios.get(`${API.Blog.Posts.app_blog_categories_posts_get}/${postId}`, config);
            return data;
        },

        createPost: async (postData) => {
            const { data } = await axios.post(API.Blog.Posts.app_blog_categories_posts_add, postData, multipartConfig);
            return data;
        },

        updatePost: async (postId, postData) => {
            const { data } = await axios.put(`${API.Blog.Posts.app_blog_categories_posts_update}/${postId}`, postData, multipartConfig);
            return data;
        },

        deletePost: async (postId) => {
            const { data } = await axios.delete(`${API.Blog.Posts.app_blog_categories_posts_delete}/${postId}`, config);
            return data;
        },

        // Comments
        getPostComments: async (postId, params = {}) => {
            const { data } = await axios.get(`${API.Blog.Posts.app_blog_categories_posts_allCommentsOnPost}/${postId}`, { ...config, params });
            return data;
        },

        addComment: async (postId, content) => {
            const { data } = await axios.post(API.Blog.Comments.app_blog_categories_posts_comments_add, { post_id: postId, content }, config);
            return data;
        },

        deleteComment: async (commentId) => {
            const { data } = await axios.delete(`${API.Blog.Comments.app_blog_categories_posts_comments_delete}/${commentId}`, config);
            return data;
        },

        // Reactions
        addReactionToPost: async (postId, type) => {
            const { data } = await axios.post(`${API.Blog.Reactions.app_blog_categories_posts_addReactionOnPost}/${postId}`, { type }, config);
            return data;
        },

        removeReactionFromPost: async (postId, type) => {
            const { data } = await axios.post(`${API.Blog.Reactions.app_blog_categories_posts_removeReactionOnPost}/${postId}`, { type }, config);
            return data;
        },

        getPostReactions: async (postId) => {
            const { data } = await axios.get(`${API.Blog.Posts.app_blog_categories_posts_allReactionsOnPost}/${postId}`, config);
            return data;
        },

        addReactionToComment: async (commentId, type) => {
            const { data } = await axios.post(`${API.Blog.Reactions.app_blog_categories_posts_addReactionOnComment}/${commentId}`, { type }, config);
            return data;
        },

        removeReactionFromComment: async (commentId, type) => {
            const { data } = await axios.post(`${API.Blog.Reactions.app_blog_categories_posts_removeReactionOnComment}/${commentId}`, { type }, config);
            return data;
        }
    };
};

export default createBlogService;
